import React, {Component} from 'react';
import {connect} from "react-redux";
import {getUserBalance} from "../../../services/state-management/actions/common/users/UsersActions";
import PropTypes from 'prop-types';
import {fetchUser} from "../../../services/state-management/actions/auth/AuthActions";

class Balance extends Component {

    static propTypes = {

        getUserBalance: PropTypes.func.isRequired,
        balance: PropTypes.string.isRequired,
        fetchUser: PropTypes.func.isRequired

    };

    componentDidMount() {

        this.props.getUserBalance();
        this.props.fetchUser();

    }

    checkPlan = () => {

        const {plan} = this.props.user;
        const {wallet} = this.props;

        if(plan){
            switch (plan.name) {
                case "Basic unlimited plan":
                    return <span className="saving"><b>Unlimited</b></span>;

                default:
                    return <span className="saving">
                        <b>{typeof (wallet) === "string" ? Number(wallet).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) : null}</b>
                    </span>
            }

        } else return null

    };

    render() {

        return (
            <div className="wallet-balance col-md-2 ml-auto mt-2 mb-3 p-0">
                <div className="icon pr-2">
                    <img src="https://res.cloudinary.com/teewhy/image/upload/v1546529222/customerportal-balance.fw.png" alt=''/>
                </div>
                <div>
                    <h5 className="count mt-1">
                        {this.checkPlan()}
                        <br />
                        <span className="baby-font">Wallet Balance</span></h5>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({

    wallet: state.wallet.wallet,
    user: state.auth.auth

});

export default connect(mapStateToProps, {getUserBalance, fetchUser})(Balance);